<template>
  <div class="mb-3">
    <b-form-group
      :class="title_position" 
      :label-cols-lg="labels_lg"
      id="example text"
      :label="FormDataType.FieldTitle"
      label-for="text"
    >
      <b-form-input
        :class="{ 'is-invalid': v.$error }"
        v-model="InputName" 
        :value="InputName"
        id="date"
        @input="$emit('input', InputName )"
        type="date"
        :disabled="FormDataType.Disabled"
      ></b-form-input>
      <template v-if="v.$error">
        <div v-for="(error, index) of v.$silentErrors" :key="index">
         <div> 
           <span v-if="error.$validator == 'required'">{{  $t("ValidationMessage.required") }}</span>
          <span v-else>{{ error.$message}}</span>
          </div>
        </div>
      </template> 
    </b-form-group>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      InputName: "",
    };
  },
  props: {
    v: {
      type: Object,
    },
    Value: {
      type: String,
    },
    FormDataType: {}, 
    title_position: String,
    labels_lg: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName =  this.formatDate(this.Value);
    },
  },
  created: function () {
    this.InputName = this.formatDate(this.Value);
  },
  methods: {

    formatDate(date) {
      return String(moment(String(date)).format("YYYY-MM-DD")); 
    }
  }, 
};
</script>
